import { Padding } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import header1 from "../../Assets/hed-autocare.png";
import header from "../../Assets/header.png";


const BillHeader = ({ title, date, noDateAndTime }) => {
  const today = date ? new Date(date) : new Date();
  return (
    <>
      <div>
        
        <img src={header} alt="header" style={{ width: "100%"  }}  />

      </div>


    </>
  );
};

export default BillHeader;
